// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uauV","type":"styles_type__2KQmy","choices":"styles_choices__2EIrZ"};